import React from 'react';
import PropTypes from 'prop-types';

import PrintBackgroundSelector from './PrintBackgroundSelector';
import withModal from '../../../../components/global/modal/withModal';

export const PRINT_BACKGROUND_SELECTOR_MODAL =
  'MODAL/PRINT_BACKGROUND_SELECTOR';

const propTypes = { onRequestClose: PropTypes.func };

const PrintBackgroundSelectorModal = ({ onRequestClose, ...props }) => {
  return <PrintBackgroundSelector onClose={onRequestClose} {...props} />;
};

PrintBackgroundSelectorModal.propTypes = propTypes;

export default withModal(PrintBackgroundSelectorModal, {
  name: PRINT_BACKGROUND_SELECTOR_MODAL,
  size: 'md',
  type: 'full',
  hideHeader: true,
  overlayClassName: 'print-background-selector-modal',
});
